// extracted by mini-css-extract-plugin
export default {"container":"Kl-z","bubbleNav":"Ll-z","graphic":"Ml-z","contact":"Nl-z"};